import { useCallback, useReducer, useEffect } from "react";

const reducer = (state, action) => {
    switch (action.type) {
        case "SET_BLOCK_AS_LOADED":
            const exists = state.loadedBlocks.includes(action.blockName);

            if (exists) {
                return state;
            }

            return {
                ...state,
                loadedBlocks: state.loadedBlocks.concat(action.blockName),
            };
        case "SET_ALL_BLOCKS_LOADED":
            return {
                ...state,
                allBlocksAreLoaded: true,
            };
        default:
            return state;
    }
};

const useAllBlocksLoaded = (numberOfBlocks) => {
    const initialState = {
        loadedBlocks: [],
        allBlocksAreLoaded: false,
        numberOfBlocks,
    };

    const [state, dispatch] = useReducer(reducer, initialState);

    const setBlockAsLoaded = useCallback(
        (blockName) => dispatch({ type: "SET_BLOCK_AS_LOADED", blockName }),
        [],
    );

    useEffect(() => {
        if (state.loadedBlocks.length === state.numberOfBlocks) {
            dispatch({ type: "SET_ALL_BLOCKS_LOADED" });
        }
    }, [state.loadedBlocks, state.numberOfBlocks]);

    return {
        allBlocksAreLoaded: state.allBlocksAreLoaded,
        setBlockAsLoaded,
    };
};

export default useAllBlocksLoaded;
